/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');

// window.Vue = require('vue');

// /**
//  * The following block of code may be used to automatically register your
//  * Vue components. It will recursively scan this directory for the Vue
//  * components and automatically register them with their "basename".
//  *
//  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
//  */

// // const files = require.context('./', true, /\.vue$/i)
// // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */

// const app = new Vue({
//     el: '#app',
// });

window.$ = window.jQuery = require('jquery');


import Swiper from 'swiper';

var mySwiper = new Swiper ('.home_swiper', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    speed: 1500,
    autoplay: {
        delay: 4000,
    },
    // pagination: {
    //     el: '.pagination1',
    //     clickable: true,
    // },
});

var mySwiper = new Swiper ('.services_swiper', {
    // slidesPerView : 3,
    speed: 1500,
    spaceBetween : 30,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.pagination1',
        clickable: true,
    },
    breakpoints: {
      320: {  //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 10
      },
      768: {  //当屏幕宽度大于等于768
        slidesPerView: 2,
        spaceBetween: 30
      },
      1280: {  //当屏幕宽度大于等于1280
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
});

var mySwiper = new Swiper ('.products_swiper', {
    // slidesPerView : 3,
    // slidesPerGroup : 3,
    speed: 1500,
    spaceBetween : 30,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.pagination2',
        clickable: true,
    },
    breakpoints: {
      320: {  //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 10
      },
      768: {  //当屏幕宽度大于等于768
        slidesPerView: 2,
        spaceBetween: 30
      },
      1280: {  //当屏幕宽度大于等于1280
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
});
